var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { compose } from 'redux';
import * as actions from '../../store/resellerSelectedManagedOrgDevPlan/actions';
import { selectOrganizations } from '../Root/selectors';
import { Helmet } from 'react-helmet';
import { PageHeader, PageHeaderTitle, PageWrapper, } from '../../components/Page';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import AddonsComponent from '../../components/DeveloperPlans/AddonsComponent';
import { selectDevPlanBundles, selectDevPlanBundlesOrg, makeSelectActiveDeveloperPlan, makeSelectActiveBundles, selectUpdatedAddons, selectDevPlanInvoiceDetailsOrg, selectDevPlanInvoiceDetails, selectPurchaseDevPlanBundleLoading, selectPurchaseDevPlanBundleError, selectProratedAmountForAddons, } from '../../store/resellerSelectedManagedOrgDevPlan/selectors';
import { LoadingSpinner } from '../../components/base';
import { LoaderPosition } from '../../components/Page/styles';
import { useErrorToast, useSuccessToast } from '../../utils/hooks/toast';
var ResellerSelectedManagedOrgDevPlansAddons = function (_a) {
    var organizations = _a.organizations, listDeveloperPlans = _a.listDeveloperPlans, bundles = _a.bundles, bundlesOrg = _a.bundlesOrg, listBundles = _a.listBundles, activeDeveloperPlan = _a.activeDeveloperPlan, activeBundles = _a.activeBundles, updatedAddons = _a.updatedAddons, getActiveBundles = _a.getActiveBundles, updateActiveBundles = _a.updateActiveBundles, updateUpdatedAddons = _a.updateUpdatedAddons, addBundlesToDevPlanManagedOrg = _a.addBundlesToDevPlanManagedOrg, removeBundlesFromDevPlanManagedOrg = _a.removeBundlesFromDevPlanManagedOrg, getDevPlanInvoiceDetails = _a.getDevPlanInvoiceDetails, devPlanInvoiceDetails = _a.devPlanInvoiceDetails, devPlanInvoiceDetailsOrg = _a.devPlanInvoiceDetailsOrg, purchase_dev_plan_bundle_loading = _a.purchase_dev_plan_bundle_loading, purchase_dev_plan_bundle_error = _a.purchase_dev_plan_bundle_error, getProratedAmountForAddons = _a.getProratedAmountForAddons, proratedAmountForAddons = _a.proratedAmountForAddons;
    var params = useParams();
    var _b = params.resellerOrgId, resellerOrgId = _b === void 0 ? '' : _b, _c = params.managedOrgId, managedOrgId = _c === void 0 ? '' : _c;
    var resellerOrg = organizations.find(function (org) { return org.id === resellerOrgId; });
    var managedOrg = organizations.find(function (org) { return org.id === managedOrgId; });
    var crumbs = [{ to: '', text: 'Developer Plans' }];
    if (managedOrgId) {
        crumbs = [
            { to: '/partner/resellers', text: 'Resellers' },
            {
                to: "/partner/resellers/".concat(resellerOrgId),
                text: (resellerOrg === null || resellerOrg === void 0 ? void 0 : resellerOrg.name) || 'Loading...',
            },
            {
                to: "/partner/resellers/".concat(resellerOrgId, "/managedOrg/").concat(managedOrgId, "/developerPlans/usage"),
                text: "".concat((managedOrg === null || managedOrg === void 0 ? void 0 : managedOrg.name) || 'Loading...', ": Usage"),
            },
            {
                to: '',
                text: 'Addons',
            },
        ];
    }
    useEffect(function () {
        (activeDeveloperPlan === null || activeDeveloperPlan === void 0 ? void 0 : activeDeveloperPlan.id) &&
            listBundles(resellerOrgId, managedOrgId, activeDeveloperPlan.id);
        listDeveloperPlans(resellerOrgId, managedOrgId);
        getActiveBundles(resellerOrgId, managedOrgId);
        getDevPlanInvoiceDetails(resellerOrgId, managedOrgId);
        updateUpdatedAddons([]);
    }, [
        resellerOrgId,
        managedOrgId,
        listBundles,
        getActiveBundles,
        listDeveloperPlans,
        getDevPlanInvoiceDetails,
        activeDeveloperPlan.id,
        updateUpdatedAddons,
    ]);
    useErrorToast('An error occurred while updating developer plan', [
        !purchase_dev_plan_bundle_loading,
        purchase_dev_plan_bundle_error,
    ]);
    useSuccessToast('Bundles successfully Updated', [
        !purchase_dev_plan_bundle_loading,
        !purchase_dev_plan_bundle_error,
    ]);
    var onUpdateAddons = function (updatedAddons) { return __awaiter(void 0, void 0, void 0, function () {
        var addedBundles, removedBundles, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    addedBundles = [], removedBundles = [];
                    (updatedAddons || []).map(function (entity) {
                        entity.quantity > 0
                            ? addedBundles.push(entity)
                            : removedBundles.push(entity);
                    });
                    _a = addedBundles.length;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, addBundlesToDevPlanManagedOrg(resellerOrgId, managedOrgId, addedBundles.map(function (entity) {
                            var _a;
                            return ({
                                bundle: (_a = entity.bundle) === null || _a === void 0 ? void 0 : _a.id,
                                quantity: entity.quantity,
                            });
                        }) || [])];
                case 1:
                    _a = (_c.sent());
                    _c.label = 2;
                case 2:
                    _a;
                    _b = removedBundles.length;
                    if (!_b) return [3 /*break*/, 4];
                    return [4 /*yield*/, removeBundlesFromDevPlanManagedOrg(resellerOrgId, managedOrgId, removedBundles.map(function (entity) {
                            var _a;
                            return ({
                                bundle: (_a = entity.bundle) === null || _a === void 0 ? void 0 : _a.id,
                                quantity: entity.quantity * -1,
                            });
                        }) || [])];
                case 3:
                    _b = (_c.sent());
                    _c.label = 4;
                case 4:
                    _b;
                    updateUpdatedAddons([]);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: _jsxs(PageWrapper, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Developer Plans" }) }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), activeBundles && bundles.length > 0 && bundlesOrg === managedOrgId ? (_jsx(AddonsComponent, { bundles: bundles, activeBundles: activeBundles, updatedAddons: updatedAddons, updateActiveBundles: updateActiveBundles, updateUpdatedAddons: updateUpdatedAddons, activeDeveloperPlan: activeDeveloperPlan, getProratedAmountForAddons: function (bundles) {
                        return getProratedAmountForAddons(resellerOrgId, managedOrgId, bundles);
                    }, onUpdateAddons: onUpdateAddons, devPlanInvoiceDetails: devPlanInvoiceDetailsOrg === managedOrgId
                        ? devPlanInvoiceDetails
                        : {}, proratedAmountForAddons: proratedAmountForAddons })) : (_jsx(LoaderPosition, { children: _jsx(LoadingSpinner, {}) }))] }) }));
};
var mapStateToProps = function (state) { return ({
    organizations: selectOrganizations(state),
    bundles: selectDevPlanBundles(state),
    bundlesOrg: selectDevPlanBundlesOrg(state),
    activeDeveloperPlan: makeSelectActiveDeveloperPlan(state),
    activeBundles: makeSelectActiveBundles(state),
    updatedAddons: selectUpdatedAddons(state),
    devPlanInvoiceDetails: selectDevPlanInvoiceDetails(state),
    devPlanInvoiceDetailsOrg: selectDevPlanInvoiceDetailsOrg(state),
    purchase_dev_plan_bundle_loading: selectPurchaseDevPlanBundleLoading(state),
    purchase_dev_plan_bundle_error: selectPurchaseDevPlanBundleError(state),
    proratedAmountForAddons: selectProratedAmountForAddons(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    listDeveloperPlans: function (resellerOrgId, managedOrgId) {
        dispatch(actions.getManageDevPlanByResellerId(resellerOrgId, managedOrgId));
    },
    listBundles: function (resellerOrgId, managedOrgId, DevPlanId) {
        dispatch(actions.listBundlesPurchasableByManagedOrg(resellerOrgId, managedOrgId, DevPlanId));
    },
    getActiveBundles: function (resellerOrgId, managedOrgId) {
        return dispatch(actions.getActiveBundles(resellerOrgId, managedOrgId));
    },
    updateActiveBundles: function (activeBundles) {
        return dispatch(actions.updateActiveBundles(activeBundles));
    },
    updateUpdatedAddons: function (updatedBundles) {
        return dispatch(actions.updateUpdatedAddons(updatedBundles));
    },
    addBundlesToDevPlanManagedOrg: function (resellerOrgId, managedOrgId, bundles) {
        return dispatch(actions.addBundlesToDevPlanManagedOrg(resellerOrgId, managedOrgId, bundles));
    },
    removeBundlesFromDevPlanManagedOrg: function (resellerOrgId, managedOrgId, bundles) {
        return dispatch(actions.removeBundlesFromDevPlanManagedOrg(resellerOrgId, managedOrgId, bundles));
    },
    getDevPlanInvoiceDetails: function (resellerOrgId, managedOrgId) {
        dispatch(actions.getDevPlanInvoiceDetails(resellerOrgId, managedOrgId));
    },
    getProratedAmountForAddons: function (resellerOrgId, managedOrgId, bundles) {
        dispatch(actions.getProratedAmountForAddons(resellerOrgId, managedOrgId, bundles));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ResellerSelectedManagedOrgDevPlansAddons);
